import React, { ReactElement } from 'react';
import { StyleSheet } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';

import DownSmallIcon from '@/assets/icons/downSmall';
import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

import { SizedBox } from './SizedBox';
import { Text } from './TextComponent';
import { Row } from './lib/components';

const button = StyleSheet.create({
    chip: {
        flexGrow: 0,
        borderRadius: 10,
        paddingTop: 6,
        paddingBottom: 7,
        paddingHorizontal: 12.5,
        backgroundColor: ds.colorValue.background.neutral.subtler,
        borderCurve: 'continuous',
        borderWidth: 1,
        borderColor: ds.colorValue.border.subtle,
        alignItems: 'center',
    },
    active: {
        backgroundColor: ds.colorValue.background.neutral.subtle,
        borderColor: ds.colorValue.border.subtle,
    },
    // Filled chips read as a resting, prominent value (Social SBK design): neutral700 surface, white label.
    filled: {
        backgroundColor: ds.colorValue.background.neutral.subtler,
    },
});

export type ChipButtonProps = {
    label: string;
    active?: boolean;
    onPress: () => void;
    testID?: string;
    isDropdown?: boolean;
    iconLeft?: ReactElement;
    variant?: 'default' | 'filled';
};

export const ChipButton = ({
    label,
    active,
    onPress,
    testID,
    isDropdown,
    iconLeft,
    variant = 'default',
}: ChipButtonProps) => {
    const isFilled = variant === 'filled';
    return (
        <TouchableOpacity
            onPress={onPress}
            testID={testID}
            style={[button.chip, isFilled && button.filled, active && button.active, common.justifyCenter, common.row]}
        >
            {iconLeft ? (
                <Row>
                    {iconLeft}
                    <SizedBox value={4} />
                </Row>
            ) : null}
            <Text
                color={isFilled || active ? ds.colorToken.text.primary : 'neutral300'}
                variant="titleSmall"
                letterSpacing={-0.08}
            >
                {label}
            </Text>
            {isDropdown ? (
                <Row>
                    <SizedBox value={8} />
                    <DownSmallIcon style={common.selfCenter} />
                </Row>
            ) : null}
        </TouchableOpacity>
    );
};
